import { Button } from '@mui/material';
import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { ResourceEditContext } from 'js/components/ResourceEditProvider/ResourceEditContext';
import { CustomHandle } from 'js/components/pipelines/FlowNodes/components/CustomHandle';
import { NodeBox } from 'js/components/pipelines/cards/components/NodeBox';
import { ResourceName } from 'js/components/pipelines/cards/components/ResourceName';
import { RESOURCE_TYPE_SOURCE } from 'js/constants/resourceTypes';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import { ConnectionTypeChip } from 'new/elements/ConnectionTypeChip/ConnectionTypeChip';
import { useGetMetaInfoByConnectorType } from 'new/hooks/useGetMetaInfoByConnectorType';
import styles from './Target.module.scss';

interface TargetProps {
  data: any;
  isPreview?: boolean;
}

export const Target = memo((props: TargetProps) => {
  const { data, isPreview } = props;
  const { name: targetName, id: targetId, connection_type, parent_node_id } = data;
  const meta = connection_type ? useGetMetaInfoByConnectorType(connection_type) : null;
  const { setAction } = useContext(ResourceEditContext);
  const parentDataSetId = useSelector(
    (state: any) => state.entities.flowNodes[parent_node_id]?.data_set_id,
  );

  const handleConfigureClick = () => {
    setAction({
      resource: RESOURCE_TYPE_SOURCE,
      type: (targetId ? 'edit' : 'create') as 'edit' | 'create',
      id: targetId,
      parentDataSetId,
    });
  };

  return (
    <NodeBox data={data} className={styles.container}>
      <ResourceName {...props} selectActions={['activate', 'delete']}>
        Connector
      </ResourceName>
      <div className={styles.targetContainer}>
        <NodeBox.Title>{targetName}</NodeBox.Title>
        {meta && (
          <ConnectionTypeChip
            icon={meta.icon}
            label={meta.name}
            style={{ border: 'none', padding: 0 }}
          />
        )}
        <div className={styles.statusSection}>
          <CustomHandle label="SUCCESS" handleId="success" color="var(--color-primary-600)" />
          <CustomHandle label="FAIL" handleId="fail" color="var(--color-primary-600)" />
        </div>
      </div>
      <NodeBox.Footer className={styles.targetFooter}>
        <div className={styles.bottomActions}>
          <ChipWithCopy tooltipTitle="Copy Source ID" toCopy={targetId}>
            ID {targetId}
          </ChipWithCopy>
          {!isPreview && (
            <Button
              variant="outlined"
              color="primary"
              className={styles.configureButton}
              onClick={handleConfigureClick}
            >
              Configure
            </Button>
          )}
        </div>
      </NodeBox.Footer>
    </NodeBox>
  );
});
